import { create } from '@bufbuild/protobuf'
import { timestampFromDate } from '@bufbuild/protobuf/wkt'
import { utc } from '@date-fns/utc'
import { startOfDay, addDays } from 'date-fns'
import { createPaginationFilters } from '@/features/admin/helper/createPaginationFilters'
import { DeletedItemSelection } from '@/generated/Enumerations/DeletedItemSelection_pb'
import { ProjectSearchBy } from '@/generated/Enumerations/ProjectSearchBy_pb'
import { ProjectSortBy } from '@/generated/Enumerations/ProjectSortBy_pb'
import { SearchType } from '@/generated/Enumerations/SearchType_pb'
import {
    ProjectFiltersDto,
    ProjectFiltersDto_ColumnSearchingSchema,
    ProjectFiltersDtoSchema,
} from '@/generated/Messages/Filters_pb'

const createProjectSearching = (searchText: string) => [
    create(ProjectFiltersDto_ColumnSearchingSchema, {
        searchBy: ProjectSearchBy.NAME,
        searchText,
        searchType: SearchType.CONTAINS,
    }),
    create(ProjectFiltersDto_ColumnSearchingSchema, {
        searchBy: ProjectSearchBy.DESCRIPTION,
        searchText,
        searchType: SearchType.CONTAINS,
    }),
    create(ProjectFiltersDto_ColumnSearchingSchema, {
        searchBy: ProjectSearchBy.TENANT_ID,
        searchText,
        searchType: SearchType.CONTAINS,
    }),
]

export const projectsQueryFilters = (
    pageSize: number,
    page: number,
    sortByField: ProjectSortBy,
    sortDirectionDesc: boolean,
    searchText: string,
    showOnlyCurrentlyValid: boolean
): Partial<ProjectFiltersDto> =>
    create(ProjectFiltersDtoSchema, {
        deletedItemSelection: DeletedItemSelection.NORMAL_ONLY,
        pagination: createPaginationFilters(pageSize, page),
        sorting: [
            {
                sortBy: sortByField,
                descending: sortDirectionDesc,
            },
        ],
        searching: createProjectSearching(searchText.toLowerCase()),
        dateFrom:
            showOnlyCurrentlyValid ?
                timestampFromDate(startOfDay(new Date(), { in: utc }))
            :   undefined,
        dateTo:
            showOnlyCurrentlyValid ?
                timestampFromDate(
                    startOfDay(addDays(new Date(), 1), { in: utc })
                )
            :   undefined,
    })
